import React, { Component } from 'react'
import { Row, Col, Tag } from 'antd'
import { app, config } from "../../app"
import '../../css/expert.css'

class EMDetail extends Component {
    constructor (props) {
        super(props)
        this.state = {}
    }

    componentDidMount () {
        this._isMounted = true
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    render () {
        const { info } = this.props
        return (
            <div>
                <Row style={{ marginTop: '1rem' }}>
                    <Col span={4} offset={4}>头像: </Col>
                    <Col span={16}>
                        <div style={{ width: 140, height: 104 }}>
                            <img style={{
                                maxWidth: '100%',
                                width: 'auto',
                                height: 'auto',
                                maxHeight: '100%'
                            }} src={config.imgUrl + info.head_img} alt="头像"/>
                        </div>
                    </Col>
                </Row>
                <Row style={{ marginTop: '1rem' }}>
                    <Col span={4} offset={4}>姓名: </Col>
                    <Col span={16}>{info.name}</Col>
                </Row>
                <Row style={{ marginTop: '1rem' }}>
                    <Col span={4} offset={4}>性别: </Col>
                    <Col span={16}>{info.sex}</Col>
                </Row>
                <Row style={{ marginTop: '1rem' }}>
                    <Col span={4} offset={4}>手机号: </Col>
                    <Col span={16}>{info.mobile}</Col>
                </Row>
                <Row style={{ marginTop: '1rem' }}>
                    <Col span={4} offset={4}>是否内部: </Col>
                    <Col span={16}>{info.is_volunteer === 1 ? '是' : '否'}</Col>
                </Row>
                <Row style={{ marginTop: '1rem' }}>
                    <Col span={4} offset={4}>职称类别: </Col>
                    <Col span={16}>{info.positional}</Col>
                </Row>
                <Row style={{ marginTop: '1rem' }}>
                    <Col span={4} offset={4}>专职课程: </Col>
                    <Col span={16}>{(info.ppe_class || []).map((p, i) => {
                        return (
                            <Tag key={i}>{p.name}</Tag>
                        )
                    })}</Col>
                </Row>
                <Row style={{ marginTop: '1rem' }}>
                    <Col span={4} offset={4}>聘用期限: </Col>
                    <Col span={16}>{info.employ_start} 至 {info.employ_end}</Col>
                </Row>
                <Row style={{ marginTop: '1rem' }}>
                    <Col span={4} offset={4}>个人介绍: </Col>
                    <Col span={16}>
                        <div className="braft-output-content"
                             dangerouslySetInnerHTML={{ __html: info.descript }}
                             style={{ padding: '20px 0' }}/>
                    </Col>
                </Row>
                <Row style={{ marginTop: '1rem' }}>
                    <Col span={4} offset={4}>个人履历: </Col>
                    <Col span={16}>
                        <div className="braft-output-content"
                             dangerouslySetInnerHTML={{ __html: info.record }}
                             style={{ padding: '20px 0' }}/>
                    </Col>
                </Row>
                <Row style={{ marginTop: '1rem' }}>
                    <Col span={4} offset={4}>证书: </Col>
                    <Col span={16}>
                        {
                            (info.certificate_img || []).map((c, i) => {
                                return (
                                    <div key={i} style={{ width: '60%', marginBottom: '.5rem' }}>
                                        <img src={config.imgUrl + c} alt="证书"
                                             style={{ maxWidth: '100%', width: 'auto', height: 'auto' }}/>
                                    </div>
                                )
                            })
                        }
                    </Col>
                </Row>
            </div>
        )
    }
}

export default EMDetail



// WEBPACK FOOTER //
// ./src/routes/expert/EMDetail.jsx